/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import { RiskCardType } from '../../components/cards/risk_settings/types';

const addTitle = {
  fieldName: 'title',
  fieldType: RiskCardType.Text,
  labels: ['Title'],
  required: true,
  focus: true,
};

export const FactorAddType = [
  addTitle,
  {
    fieldName: 'options',
    fieldType: RiskCardType.AddOrRemoveItems,
    labels: ['Options', 'Values'],
    addOrRemoveItemsType: 'factorOptions',
    required: true,
  },
  {
    fieldName: 'weight',
    fieldType: RiskCardType.Number,
    labels: ['Weight'],
    required: true,
  },
];

export const VectorAddType = [
  addTitle,
  {
    fieldName: 'formula',
    title: 'Vector Calculation',
    fieldType: RiskCardType.Calculation,
    labels: ['Calculation'],
    required: true,
  },
  {
    fieldName: 'thresholds',
    title: 'Vector Threshold Ranges',
    fieldType: RiskCardType.AddOrRemoveItems,
    labels: ['Ranges', 'Up to (≤)'],
    addOrRemoveItemsType: 'vectorThresholds',
    required: true,
  },
];

export const ScoreAddType = [
  addTitle,
  {
    fieldName: 'formula',
    fieldType: RiskCardType.Calculation,
    labels: ['Calculation'],
    required: true,
  },
  {
    fieldName: 'thresholds',
    fieldType: RiskCardType.AddOrRemoveItemsWithColor,
    labels: ['Ranges', 'Up to (≤)'],
    addOrRemoveItemsType: 'scoreThresholds',
    required: true,
  },
];
